export default __webpack_public_path__ + "static/media/applications_factory.617e11a6.png";